import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { sendDelivery } from 'api/orders';
import useAnalytics from 'hooks/Analytics/useAnalytics';
import { getCurrentUser } from 'modules/utils/windowReduxStore.js';

import { revalidateOrder } from 'modules/orders';
import { fetchBasketIfNeeded } from 'modules/checkout/actions.basket';

import PISelectDeliveryContainer from 'components/Checkout/ProductIdentity/SelectDeliveryContainer.jsx';
import RoutePageView from 'components/RoutePageView.jsx';
import LoadingAnimation from 'components/LoadingAnimation.jsx';

/*
Delivery option is a string of the following form:
 - assembly
 - pickup_[pickupUuid]
 - deliveryOffer_[offerId]
*/

const CheckoutRouter = ({ orderId }) => {
    const { basket, basketPrices, selectedOption, deliveryOptions, isFetchingBasket } = useSelector(
        state => state.checkout
    );
    const user = useSelector(getCurrentUser);
    const dispatch = useDispatch();
    const { analytics } = useAnalytics();
    const onDeliveryFormSubmit = dataToSend => {
        return sendDelivery(basket.id, dataToSend).then(order => {
            analytics.trackAddShippingInfo(order, user);
            dispatch(revalidateOrder(order.id, order.distribution.id));
        });
    };

    useEffect(() => {
        dispatch(fetchBasketIfNeeded(orderId));
    }, [dispatch, orderId]);

    if (isFetchingBasket || !basketPrices || !basket) {
        return <LoadingAnimation classname="loading-anim-box-margin-top" type="pi-spinner" />;
    }

    return (
        <Router>
            <RoutePageView />
            <Switch>
                <Route
                    exact
                    path="/:locale/orders/:orderId/pickup"
                    render={props => {
                        const orderIdParam = Number(props.match.params.orderId); // eslint-disable-line react/prop-types
                        const basketId = Number(basket.id);
                        orderIdParam !== basketId && dispatch(fetchBasketIfNeeded(orderIdParam));
                        return (
                            <div>
                                <PISelectDeliveryContainer
                                    basket={basket}
                                    basketPrices={basketPrices}
                                    deliveryOptions={deliveryOptions}
                                    selectedOption={selectedOption}
                                    onDeliveryFormSubmit={onDeliveryFormSubmit}
                                />
                            </div>
                        );
                    }}
                />
            </Switch>
        </Router>
    );
};
CheckoutRouter.propTypes = {
    orderId: PropTypes.number.isRequired,
};
export default CheckoutRouter;
